<template>
	<vue-scroll>
		<div class="page-contacts flex column scrollable only-y mb-20" id="page-contacts"
			v-show="userPermissionsFilter.admin" v-loading="pageLoading" :element-loading-text="loadingText"
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
			<resize-observer @notify="__resizeHanlder" />
			<div class="contacts-root box grow flex gaps justify-center" :class="contactsClass">
				<div class="card-base card-shadow--small search-card scrollable only-y">
					<h1 class="mt-0 pageTitle">User Groups</h1>

					<el-input prefix-icon="el-icon-search" placeholder="Search a user group" clearable v-model="search">
					</el-input>

					<div class="o-050 text-right mt-10 mb-30"><strong>{{ userGroupsFiltered.length }}</strong> user
						groups
					</div>

					<el-button icon="mdi mdi-account-plus" type="primary" @click="openDialog({})"
						v-show="userPermissionsFilter.addusergroups"> add user group</el-button>
				</div>
				<div class="contacts-list box grow scrollable only-y">
					<div v-for="c in userGroupsFiltered" :key="c.id" class="flex contact" @click="openDialog(c)">
						<div class="star align-vertical p-10 fs-22">
							<i class="mdi mdi-checkbox-marked-circle align-vertical-middle" v-if="c.active"></i>
							<i class="mdi mdi-checkbox-blank-circle-outline align-vertical-middle" v-if="!c.active"></i>
						</div>
						<div class="avatar align-vertical">
						</div>
						<div class="info box grow flex">
							<div class="name box grow flex column justify-center p-10">
								<div class="fullname fs-18"><strong>{{ c.groupName }}</strong></div>

								<div class="email fs-14 secondary-text accent-text">{{ c.description }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<!-- <group-dialog :dialogFormVisible.sync="dialogFormVisible" :groupdata="groupdata"
			v-on:saveCurrentGroup="saveCurrentGroup($event)" v-on:deleteCurrentGroup="deleteCurrentGroup($event)"></group-dialog> -->

			<el-dialog :show-close="true" :custom-class="'group-dialog'" :center="true" :visible="dialogFormVisible"
				@close="closeDialog" :before-close="handleClose">
				<div slot="title">
					<span><i class="mdi mdi-security accent-text"></i>
						<h2 class="accent-text">{{ dialogTitle }}</h2>
					</span>
				</div>
				<div class="form-box">
					<div class="row">
						<div class="row">
							<div class="col col-md-12">
								<el-input placeholder="Name" v-model="groupdata.groupName" :readonly="readOnlyMode"
									@change="propertyChanged"></el-input>
							</div>
						</div>

						<div class="row mt-12">
							<div class="col col-md-12">
								<el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6 }"
									placeholder="Description" :readonly="readOnlyMode" @change="propertyChanged"
									v-model="groupdata.description"></el-input>
							</div>
						</div>

						<div class="row mt-12" v-show="!readOnlyMode">
							<div class="col col-md-12">
								<el-button type="primary" class="btn-group" style="width:100%"
									@click="saveCurrentGroup">
									<i class="mdi mdi-content-save"> </i><span>Save</span>
								</el-button>
							</div>
						</div>

						<div class="row mt-12" v-show="groupdata.id != null && userPermissionsFilter.deleteusergroups">
							<div class="col col-md-12">
								<el-button type="danger" class="btn-group" style="width:100%" @click="deletePrompt">
									<i class="mdi mdi-cancel"></i><span> Delete</span>
								</el-button>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>
	</vue-scroll>
</template>


<script>
import PermissionsMixin from '@/mixins/PermissionsMixins'

export default {
	name: 'Groups',
	data() {
		return {
			search: '',
			pageWidth: 0,
			groupdata: '',
			dialogTitle: 'add user group'
		}
	},
	computed: {
		userGroupsFiltered() {
			return this.groups.filter(({ groupName }) => (groupName).toString().toLowerCase().indexOf(this.search.toString().toLowerCase()) !== -1)
		},
		contactsClass() {
			return this.pageWidth >= 870 ? 'large' : this.pageWidth >= 760 ? 'medium' : 'small'
		},
		readOnlyMode() {
			return !this.userPermissionsFilter.addusergroups
				&& !this.userPermissionsFilter.editusergroups;
		}
	},
	methods: {
		openDialog(data) {
			this.groupdata = data;
			this.dialogFormVisible = true;
		},
		setPageWidth() {
			this.pageWidth = document.getElementById('page-contacts').offsetWidth
		},
		__resizeHanlder: _.throttle(function (e) {
			this.setPageWidth()
		}, 700),
		saveCurrentGroup() {
			this.dialogFormVisible = false;
			this.saveGroup(this.groupdata);
		},
		deleteCurrentGroup() {
			this.dialogFormVisible = false;
			this.deleteGroup(this.groupdata.id);
		}
	},
	mounted() {
		this.deleteEvent = 'deleteCurrentGroup';
		this.$on(this.deleteEvent, this.deleteCurrentGroup);
		this.getGroups();
		this.setPageWidth()
	},
	mixins: [PermissionsMixin]
}
</script>


<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.page-contacts {
	color: #fff;
	height: 100%;
	margin: 0 !important;
	padding: 20px;
	padding-bottom: 10px;
	box-sizing: border-box;

	.search-card {
		padding: 50px;
		max-width: 350px;
		max-height: 320px;
		box-sizing: border-box;
		margin-bottom: 15px;

		.el-input,
		.el-button {
			width: 100%;
		}
	}

	.search-wrap {
		margin: 0 auto;
		margin-bottom: 10px;
		padding: 0px 30px;
		box-sizing: border-box;
		width: 100%;
		max-width: 600px;

		i {
			display: inline-block;
			width: 22px;
		}

		input {
			outline: none;
			background: transparent;
			border: none;
			font-size: 15px;
			position: relative;
			top: -2px;
			width: 100%;
			padding: 0;
			color: $text-color;
		}

		.contacts-tot {
			margin-right: 20px;
			margin-left: 10px;
		}

		a {
			border-bottom: 1px solid;
			text-decoration: none;
			color: $text-color;

			&:hover {
				opacity: .6;
			}
		}
	}

	.contacts-root {
		max-height: 100%;
	}

	.contacts-list {
		//margin: 0 auto;
		width: 100%;
		max-width: 965px;
		padding: 0px 30px;
		box-sizing: border-box;

		.contact {
			margin: 10px 0;
			padding: 5px;
			box-sizing: border-box;
			cursor: pointer;
			transition: all .5s .25s;

			.star {
				.mdi-star {
					color: #ffd730;
				}

				.mdi-star-outline {
					opacity: .5;
				}
			}

			.avatar {
				width: 60px;
				transition: all .5s .25s;

				img {
					border: 1px solid transparentize($text-color, .9);
					box-sizing: border-box;
					width: 50px;
					height: 50px;
					border-radius: 50%;
					transition: all .5s .25s;
				}
			}

			.info {
				word-break: break-word;

				.name {

					//.fullname {}

					.email {
						opacity: 0;
						line-height: 0;
						transition: all .5s .25s;
					}

					.phone {
						display: none;
					}
				}

				//.phone {}
			}

			&:hover {
				margin: 15px -20px;
				padding: 10px;
				background-color: lighten($background-color, 20%);
				border-radius: 5px;
				box-shadow: 0 8px 16px 0 rgba(40, 40, 90, .09), 0 3px 6px 0 rgba(0, 0, 0, .065);

				.avatar {
					width: 90px;

					img {
						width: 90px;
						height: 90px;
					}
				}

				.info {
					.name {
						.email {
							opacity: 1;
							line-height: 1.4;
						}
					}
				}
			}
		}
	}

	.contacts-root {
		&.medium {
			.search-card {
				padding: 20px;
				max-width: 260px;
				max-height: 260px;
			}
		}

		&.small {
			overflow-y: auto;
			display: block;
			-webkit-box-orient: vertical;
			-webkit-box-direction: normal;
			-ms-flex-direction: column;
			flex-direction: column;
			padding: 5px;

			.search-card {
				padding: 20px;
				max-width: 100%;
				width: 100%;
				//max-height: 240px;
				flex: none;
				-webkit-box-flex: none;
				-ms-flex: none;
				display: block;
				overflow: hidden !important;
			}

			.contacts-list {
				flex: none;
				-webkit-box-flex: none;
				-ms-flex: none;
				display: block;
				overflow: hidden !important;
			}
		}
	}
}

@media (max-width: 768px) {
	.page-contacts {
		.search-wrap {
			padding: 0;
		}

		.contacts-list {
			padding: 0px;

			.contact {
				.avatar {
					width: 40px;

					img {
						width: 40px;
						height: 40px;
					}
				}

				.info {
					.phone {
						display: none;
					}

					.name {
						.phone {
							display: block;
						}
					}
				}

				&:hover {
					margin: 15px 0px;

					.avatar {
						width: 60px;

						img {
							width: 60px;
							height: 60px;
						}
					}
				}
			}
		}

		.contacts-root {
			&.medium {
				.contacts-list {
					padding: 0 30px;
				}
			}

			&.small {
				.contacts-list {
					padding: 8px;
				}
			}
		}
	}
}
</style>